/**
 * Mobile sticky add-to-cart bar.
 * Shows its bar once the main add-to-cart button (data-target id) has scrolled
 * above the viewport, and hides it again when that button is back in view.
 * While hidden the bar is inert so it never takes focus.
 */
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const bar = this.querySelector('[data-sticky-bar]');
    const targetId = this.dataset.target;
    const target = targetId ? document.getElementById(targetId) : null;
    if (!bar || !target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.toggleAttribute('data-visible', scrolledPast);
      bar.inert = !scrolledPast;
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', SStickyBuy);
}
